import styled from 'styled-components';
import { ShortBody } from 'components/Typography';
import { Link } from '@material-ui/core';

export const StyledShortBody = styled(ShortBody)`
  font-size: 13px !important;
  margin-bottom: 0px !important;
  line-height: 16px !important;
`;

export const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none !important;
  }
`;
